import { Card, Image, Select, Input, Badge, Col } from "antd";
import { makeFileURL } from "../../../utils/common";
import { APPROVED_REJECT_OPTION, colProps } from "../../../constants/constent";
import assets from "../../../utils/ImagesPath";

function DocumentCard({
  doc,
  vendorDocs,
  docStatus,
  docRemarks,
  onStatus,
  onRemark,
}) {
  const status = docStatus[doc.statusKey];

  return (
    <Col {...colProps}>
      <Badge.Ribbon
        text={status?.toUpperCase()}
        color={
          status === "approved"
            ? "green"
            : status === "reject"
              ? "red"
              : "orange"
        }
      >
        <Card title={doc.label}>
          <Image
            src={
              vendorDocs?.[doc.imageKey]?.filePath
                ? makeFileURL(vendorDocs[doc.imageKey].filePath)
                : assets.imagePlaceholder
            }
            width="100%"
            style={{
              maxHeight: 200,
              objectFit: "cover",
              borderRadius: "8px",
              backgroundColor: "#f0f0f0",
            }}
            preview={!!vendorDocs?.[doc.imageKey]?.filePath}
            fallback={assets.imagePlaceholder}
          />

          <Select
            value={status}
            disabled={!vendorDocs?.[doc.imageKey]?.filePath}
            onChange={(v) => onStatus(doc.statusKey, v)}
            options={APPROVED_REJECT_OPTION}
            style={{ width: "100%", marginTop: 8 }}
          />

          {status === "reject" && (
            <Input.TextArea
              rows={2}
              value={docRemarks[doc.remarkKey]}
              onChange={(e) => onRemark(doc.remarkKey, e.target.value)}
              style={{ width: "100%", marginTop: 8 }}
            />
          )}
        </Card>
      </Badge.Ribbon>
    </Col>
  );
}

export default DocumentCard;
